import { getMetricFromPodiumLevels as r } from "../index5.js";
import { getLevelGrossFacadeArea as o } from "../level-metrics/index22.js";
const a = (e) => r(e, o);
export {
  a as getPodiumGrossFacadeArea
};
//# sourceMappingURL=index41.js.map
